import { useQuery } from '@tanstack/react-query';
import { PROFILE_REFRESH_INTERVAL_IN_MILISECONDS } from '../../global.constants';
import { PermissionUrn } from '../../pages/UserSettings/Roles/api/permissions.type';
import { UserApi } from './user.api';

export const USER_QUERY_KEY = 'manifest-user';

export interface UserPermissionsResponse {
  permissions: PermissionUrn[];
}

export const useFetchUserPermissions = ({
  userId,
  options,
}: {
  userId: string;
  options?: {
    enabled?: boolean;
  };
}) => {
  return useQuery({
    queryKey: [USER_QUERY_KEY, `user/self/permissions`, userId],
    queryFn: (): Promise<UserPermissionsResponse> => UserApi.getUserPermissions(),
    staleTime: PROFILE_REFRESH_INTERVAL_IN_MILISECONDS,
    enabled: Boolean(userId) && (options?.enabled ?? true),
  });
};
